(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var WIDGET_SEL = '.tl-custom-cart-goal-container';
  var TARGET_SEL = '#MainContent [id^="price-template--"].flex.flex-wrap.items-center.gap-4';
  var EXCLUDE_SEL = 'cart-drawer, #CartDrawer, .cart-drawer, [id*="cart-drawer"], [class*="drawer"]';

  var running = false;

  function moveWidget() {
    if (running) return;
    var target = document.querySelector(TARGET_SEL);
    if (!target) return;

    // Only touch product-page widgets, not the ones in the cart drawer
    var widgets = Array.prototype.filter.call(
      document.querySelectorAll(WIDGET_SEL),
      function (el) { return !el.parentElement.closest(EXCLUDE_SEL); }
    );
    if (!widgets.length) return;

    running = true;
    var main = widgets[0];
    if (main.nextElementSibling !== target) {
      target.insertAdjacentElement('beforebegin', main);
    }
    main.classList.add('tl-cart-goal--pdp');
    main.style.width = '100%';

    // The selector matches more than one element, so remove the duplicates
    for (var i = 1; i < widgets.length; i++) widgets[i].remove();
    running = false;
  }

  var timer;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(moveWidget, 50);
  });

  function init() {
    moveWidget();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// custom luôn hiển thị YMAL
(function () {
  function patch(app) {
    if (!app || app.__tlCheckCartPatched) return;
    app.__tlCheckCartPatched = true;

    app.checkCartData = async () => {
      const isCartPage = window.location.pathname === "/cart";
      const cartData = await app.getCartAjax();
      if (!cartData && isCartPage) return null;

      const productInCart = new Set();
      const ruleIdMapAddedRecommendProd = new Map();
      (cartData?.items ?? []).forEach((item) => {
        const productId = String(item.product_id);
        const ruleId = item.properties?.[app.PROPERTY];
        if (ruleId) {
          const added = ruleIdMapAddedRecommendProd.get(ruleId) ?? [];
          ruleIdMapAddedRecommendProd.set(ruleId, [...added, productId]);
        }
        productInCart.add(productId);
      });

      // Ngoài trang cart: trigger theo sản phẩm đang xem
      const currentProductId =
        window.productId ??
        window.ShopifyAnalytics?.meta?.product?.id ??
        window.meta?.product?.id;
      const triggerProducts = isCartPage
        ? Array.from(productInCart)
        : (currentProductId ? [String(currentProductId)] : []);

      app.ruleIdMapAddedRecommendProd = new Map(ruleIdMapAddedRecommendProd);
      return { productInCart: triggerProducts, ruleIdMapAddedRecommendProd };
    };
  }

  // Script chạy SAU app: patch trực tiếp rồi tính lại widget
  if (window.tlYMAL) {
    patch(window.tlYMAL);
    window.tlYMAL.checkApplyOffer?.();
    return;
  }

  // Script chạy TRƯỚC app: chờ app gán window.tlYMAL rồi patch
  let instance;
  Object.defineProperty(window, "tlYMAL", {
    configurable: true,
    enumerable: true,
    get() { return instance; },
    set(val) { instance = val; patch(val); },
  });
})();

